import { ListTaxiparks } from '~/features/Taxiparks'

export function ListTaxiparksPage() {
  return <ListTaxiparks />
}
